<template>
    <hooper :progress="true" :autoPlay="true" :playSpeed="3000 " style="height: 500px">
    <!--<hooper style="height: 500px">-->
        <!--<slide v-for="(slide, indx) in slides" :key="indx" :index="indx">
        {{ slide.title }}
        </slide>-->
        <slide style="background-image: url('/nc/gfx/hero/hero_slide_1.jpg')">
            <div class="hero-slider-container" style="margin-top: ">
                <div class="hero-slider-title">
                    Nigels Cars
                </div>
                <div class="hero-slider-text">
                    Affordable Quality Used Cars
                </div>
                <a href="/showroom" class="btn btn-lg btn-primary">View Showroom</a>
            </div>
        </slide>
        <slide style="background-image: url('/nc/gfx/hero/hero_slide_2.jpg')">
            <div class="hero-slider-container" style="margin-top: ">
                <div class="hero-slider-title">
                    Nigels Cars
                </div>
                <div class="hero-slider-text">
                    Warranty &amp; MOT with all cars
                </div>
                <a href="/showroom" class="btn btn-lg btn-primary">View Showroom</a>
            </div>
        </slide>
        <slide style="background-image: url('/nc/gfx/hero/hero_slide_3.jpg')">
            <div class="hero-slider-container" style="margin-top: ">
                <div class="hero-slider-title">
                    Nigels Cars
                </div>
                <div class="hero-slider-text">
                    Finanace Available
                </div>
                <a href="/showroom" class="btn btn-lg btn-primary">View Showroom</a>
            </div>
        </slide>
    </hooper>
</template>

<script>
import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
    name: 'HeroSlider',
    components: {
        Hooper,
        Slide
    },
    data: function(){
        return {
            slides: [
                {"title": "Hello World", "message": "This is a greeting"},
                {"title": "Goodbye World", "message": "This is a valediction"}
                ]
            };
        }
    };
</script>
